import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";

import PrimaryButton from "../../../../../../../../../components/Buttons/PrimaryButton";
import {NameColNew} from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/Portfolio/table-data";
import SelectFormElement from "../../../../formElement/SelectFormElement";
import {isRequiredQuestion} from "../../../../../../../utils";
import {newDesignInputCustomClasses} from "../../../../../../../constants";
import CheckboxFormElement from "../../../../formElement/CheckboxFormElement/CheckboxFormElement";
import BaseDialog from "../../../../../../../../../components/BaseDialog/BaseDialog";
import {SelectQuestionMethods} from "../../../../question/SelectQuestion";
import {BcaIconButtonTooltip} from "../../../../../../../../../components/Buttons/BcaIconButton/BcaIconButton";

import styles from "./styles";


const _convertToForm = (item) => ({
  order_type: item.order_type_option,
  valid_until: item.valid_until_option,
  stock_exchange: item.stock_exchange_option,
  errors: item.errors || {}
});

const _convertFromForm = (item) => ({
  order_type: item.order_type.value,
  order_type_option: item.order_type,
  valid_until: item.valid_until.value,
  valid_until_option: item.valid_until,
  stock_exchange: item.stock_exchange.value,
  stock_exchange_option: item.stock_exchange,
  errors: {...item.errors, stock_exchange: null, valid_until: null, order_type: null}
});

const SharesSettings = (props) => {
  const {
    classes,
    item,
    orderTypeOptions,
    validityDateOptions,
    stockExchangeOptions,
    onChange,
    hasMultipleShares
  } = props;

  const [settingsModalOpen, setSettingsModalOpen] = React.useState(false);
  const [formData, setFormData] = React.useState(_convertToForm(item));

  const handleClose = () => {
    setSettingsModalOpen(false);
    setFormData(_convertToForm(item)); // cancel changes
  };

  const onOpen = () => {
    setFormData(_convertToForm(item)); // init
    setSettingsModalOpen(true)
  };

  const handleSave = () => {
    const errors = {};

    // validate orderType
    if(!SelectQuestionMethods.valid(orderTypeQ)){
      errors.order_type = orderTypeQ.error
    }
    // validate validityDate
    if(!SelectQuestionMethods.valid(validityDateQ)){
      errors.valid_until = validityDateQ.error
    }
    // validate stockExchange
    if(!SelectQuestionMethods.valid(stockExchangeQ)){
      errors.stock_exchange = stockExchangeQ.error
    }

    if(!_.isEmpty(errors)){
      setFormData({...formData, errors});
      return false;
    }

    onChange(item, _convertFromForm(formData), hasMultipleShares && formData.populate);
    setSettingsModalOpen(false);
  };

  const orderTypeQ = {
    optional: false,
    answer: _.get(formData.order_type, 'value'),
  };

  const validityDateQ = {
    optional: false,
    answer: _.get(formData.valid_until, 'value'),
  };

  const stockExchangeQ = {
    optional: false,
    answer: _.get(formData.stock_exchange, 'value'),
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={true}>
        <div>{item.order_type_option.label}</div>
        <div>{item.valid_until_option.label}</div>
        <div>{item.stock_exchange_option.label}</div>
      </Grid>
      <Grid item xs={'auto'} className={classes.icon}>
        <BcaIconButtonTooltip tooltip={'Order einrichten'}>
          <i className={'far fa-money-check-edit-alt'} onClick={onOpen} />
        </BcaIconButtonTooltip>
      </Grid>
      <BaseDialog
        open={settingsModalOpen}
        handleClose={handleClose}
        title={'Order einrichten'}
        maxWidth={'sm'}
        actions={
          <Grid container justify={"flex-end"} spacing={2}>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton
                text="Abbrechen"
                variant="outlined"
                onButtonClick={handleClose}
              />
            </Grid>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton text={"Speichern"} onButtonClick={handleSave} />
            </Grid>
          </Grid>
        }
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div>Für Order:</div>
            <div>{NameColNew.body[0]({item, options: {hideAcceptanceCriteriasUnderName: true}})}</div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectFormElement
              label={'Orderzusatz'}
              value={orderTypeQ.answer || ''}
              options={orderTypeOptions || []}
              onChange={
                (value) => setFormData({
                  ...formData,
                  order_type: orderTypeOptions.find(o => o.value == value),
                  errors: {...formData.errors, order_type: null}
                })
              }
              required={isRequiredQuestion(orderTypeQ)}
              error={formData.errors.order_type}
              custom_classes={newDesignInputCustomClasses}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectFormElement
              label={'Gültigkeit'}
              value={validityDateQ.answer || ''}
              options={validityDateOptions || []}
              onChange={
                (value) => setFormData({
                  ...formData,
                  valid_until: validityDateOptions.find(o => o.value == value),
                  errors: {...formData.errors, valid_until: null}
                })
              }
              required={isRequiredQuestion(validityDateQ)}
              error={formData.errors.valid_until}
              custom_classes={newDesignInputCustomClasses}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectFormElement
              label={'Börsenplatz'}
              value={stockExchangeQ.answer || ''}
              options={stockExchangeOptions || []}
              onChange={
                (value) => setFormData({
                  ...formData,
                  stock_exchange: stockExchangeOptions.find(o => o.value == value),
                  errors: {...formData.errors, stock_exchange: null}
                })
              }
              required={isRequiredQuestion(stockExchangeQ)}
              error={formData.errors.stock_exchange}
              custom_classes={newDesignInputCustomClasses}
            />
          </Grid>
          {hasMultipleShares && (
            <Grid item xs={12}>
              <CheckboxFormElement
                label={'Auswahl für alle Order übernehmen'}
                value={formData.populate}
                onChange={(val) => setFormData({...formData, populate: val})}
                custom_classes={{label: classes.checkboxLabel}}
              />
            </Grid>
          )}
        </Grid>
      </BaseDialog>
    </Grid>
  )
};

export default withStyles(styles)(SharesSettings);